import { QRCodeSVG } from "qrcode.react";

const PLATFORM_INSTRUCTIONS: Record<string, string> = {
  whatsapp:
    "On the avatar phone: WhatsApp → Settings → Linked Devices → Link with phone number → enter the code below.",
  signal: "On Signal (primary device): Settings → Linked Devices → Link New Device → scan.",
  telegram: "Scan with the Telegram app, or enter the code on the linked device.",
};

// Format an 8-digit pairing code as "XXXX-XXXX" for readability.
function formatPairingCode(code: string): string {
  if (!code) return "";
  if (code.length === 8) return `${code.slice(0, 4)}-${code.slice(4)}`;
  return code;
}

export function QrStep({
  qrText,
  pairingCode,
  instruction,
  platform,
  onCancel,
}: {
  qrText?: string | undefined;
  pairingCode?: string | undefined;
  instruction?: string | undefined;
  platform: string;
  onCancel: () => void;
}) {
  const message =
    instruction ?? PLATFORM_INSTRUCTIONS[platform] ?? "Follow the platform's link-device flow.";

  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      {pairingCode ? (
        <>
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 2,
              textTransform: "uppercase",
              color: "var(--iris-ok, #15803d)",
              marginBottom: 4,
            }}
          >
            ✓ Code received — type this on the phone
          </div>
          <div
            style={{
              fontFamily:
                "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
              fontSize: 42,
              letterSpacing: 8,
              fontWeight: 700,
              padding: "20px 12px",
              background: "var(--iris-bg-3, #f6f7f9)",
              border: "2px solid var(--iris-line-2, #d1d5db)",
              borderRadius: 10,
              userSelect: "all",
              cursor: "text",
            }}
            aria-label="Pairing code"
          >
            {formatPairingCode(pairingCode)}
          </div>
          <div style={{ marginTop: 6, fontSize: 11, color: "var(--iris-fg-4)" }}>
            Click the code to select it. If it expires before you finish, the platform issues a new
            code automatically.
          </div>
        </>
      ) : qrText ? (
        <>
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 2,
              textTransform: "uppercase",
              color: "var(--iris-ok, #15803d)",
              marginBottom: 8,
            }}
          >
            ✓ QR ready — scan on the device
          </div>
          <QRCodeSVG value={qrText} size={256} />
        </>
      ) : (
        <div style={{ color: "var(--iris-fg-4)" }}>Waiting for code…</div>
      )}
      <div style={{ marginTop: 16, fontSize: 13, lineHeight: 1.55 }}>{message}</div>
      <button type="button" className="iris-btn" style={{ marginTop: 20 }} onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
